import React, { useState } from "react";
import { CommonGrid2 } from "../common-components/StyledComponents";
import { Dialog, DialogContent, Typography } from "@mui/material";
import QuestionMarkIco from "../../assets/icons/QuestionMarkIco";
import CreditCoinSmallIco from "../../assets/icons/CreditCoinSmallIco";
import CreditBalancer from "../../assets/images/CreditBalancer.svg";
import CreditCoinsLarge from "../../assets/images/CreditCoinsLarge.svg";
import { CustomDiv } from "../chat-bot/style";
import { CustomizeSpan } from "../jobs/style";
import CommonButton from "../../component/Button";
import { BuyCredits as BuyCreditsAction } from "../../redux/action/Credit";
import SnackBar from "../../component/SnackBar";
import CommonTextField from "../../component/Input";
import { platformBlackLogo } from "../../utils/logo";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

function BuyCredits() {
    const [creditsForm, setCreditsForm] = useState(false);
    const [successDialog, setSuccessDialog] = useState(false);
    const [creditsFormValue, setCreditsFormValue] = useState({
        requested_credits: "",
        additional_notes: ""
    });
    const [snackbarState, setSnackbarState] = useState({
        open: false,
        message: "",
        severity: ""
    })
    const [loading, setLoading] = useState(false);
    const [logout, setLogout] = useState({
        logoutLoading: false,
        open: false,
        disabled: false,
        noLoading: false,
    });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const URL = process.env.REACT_APP_WEBSITE_URL;


    const handleSendCreditRequest = async () => {
        try {
            setLoading(true);
            const response = await BuyCreditsAction(creditsFormValue);
            setLoading(false);
            if (response.success) {
                setCreditsForm(false);
                setSuccessDialog(true);
                setCreditsFormValue({
                    requested_credits: "",
                    additional_notes: ""
                })
            }
        } catch (error) {
            setLoading(false);
            setSnackbarState({
                open: true,
                message: error?.message,
                severity: "error"
            })
            setCreditsFormValue({
                requested_credits: "",
                additional_notes: ""
            })
        }
    }
    const handleCloseValidation = () => {
        setSnackbarState((prev) => ({
            ...prev,
            open: false,
        }));
    };
    const handleLogout = () => {
        setLogout({
            noLoading: false,
            open: false,
            logoutLoading: false,
            disabled: false,
        });
    };

    const handleClickOpen = () => {
        window.open(`${URL}/contact-us`, "_blank", "noopener,noreferrer");
    };

    return (
        <CommonGrid2
            display={"flex"}
            flexDirection={"column"}
            height={"100vh"}
            padding={"2rem"}
        >
            <CommonGrid2
                gap={"2rem"}
                display={"flex"}
                justifyContent={"space-between"}
                flexWrap={"wrap"}
                alignItems={"center"}
            >
                <CustomDiv width="fit-content">
                    {platformBlackLogo({height: "50px"})}
                </CustomDiv>
                <CommonGrid2 display={"flex"} gap={"2rem"}>
                    <CommonButton
                        value={"Contact Us"}
                        padding={"10px"}
                        variant="outlined"
                        color="#344054"
                        fontWeight={"700"}
                        border={"transparent"}
                        width={"150px"}
                        height="fit-content"
                        onClick={() => handleClickOpen()}
                    />
                    <CommonButton
                        value={"Logout"}
                        padding={"10px"}
                        width={"150px"}
                        fontWeight={"700"}
                        height="fit-content"
                        onClick={() => {
                            setLogout((prev) => ({
                                ...prev,
                                open: true,
                            }));
                            setTimeout(() => {
                                localStorage.clear();
                                dispatch({ type: "RESET_ALL" });
                                navigate("/auth/login");
                              }, 1000);
                        }}
                        loading={logout.logoutLoading}
                        disabled={logout.disabled}
                    />
                </CommonGrid2>
            </CommonGrid2>
            <Typography variant="h2" margin={"1rem 0"} >Shop</Typography>
            <CommonGrid2
                display={"flex"}
                flexDirection={"row"}
                padding={"1rem"}
                justifyContent={"space-between"}
                alignItems={"center"}
                background={"#F8F3FF"}
                borderRadius={"10px"}
            >
                <CommonGrid2
                    display={"flex"}
                    flexDirection={"column"}
                    gap={"1rem"}
                >
                    <Typography variant="h5" fontWeight={700}>Buy Credits</Typography>

                    <CommonGrid2
                        display={"flex"}
                        flexDirection={'row'}
                        gap={"1rem"}
                    >
                        <QuestionMarkIco />
                        <CustomDiv
                            display={"flex"}
                            alignItems={"center"}
                            customStyle={{
                                flexDirection: "column",
                            }}
                        >
                            <Typography variant="body1" fontWeight={700}>
                                <CustomizeSpan><CreditCoinSmallIco /></CustomizeSpan>
                                1 Credit = 1 AI task.
                            </Typography>
                            <Typography variant="body1" fontWeight={400}>
                                Eg: If
                                <CustomizeSpan color="#6947B0" fontWeight={700}> 1 Quick Match </CustomizeSpan>task involving
                                <CustomizeSpan color="#0070F2" fontWeight={700}> 1 JD Enrichment </CustomizeSpan>and
                                <CustomizeSpan color="#FF7200" fontWeight={700}> 5 Resumes </CustomizeSpan>it will cost you
                                <CustomizeSpan><CreditCoinSmallIco /></CustomizeSpan>
                                <CustomizeSpan fontWeight={700}>7 Credits.</CustomizeSpan>
                            </Typography>
                        </CustomDiv>
                    </CommonGrid2>
                </CommonGrid2>
                <CommonGrid2
                    position={"relative"}
                    top={"-5rem"}
                    height={"100px"}
                >
                    <img
                        src={CreditBalancer}
                        alt="Credit Balancer"
                    />
                </CommonGrid2>
            </CommonGrid2>
            <CommonGrid2
                display={"flex"}
                flexDirection={"column"}
                padding={"1rem"}
                container
                spacing={2}
                justifyContent={"center"}
                alignItems={"center"}
                gap={"1rem"}
                border={"1px solid #EAECF0"}
                borderRadius={"10px"}
                width={"fit-content"}
                customStyle={{
                    marginTop: "1rem"
                }}
                size={4}
            >
                <img src={CreditCoinsLarge} />
                <Typography variant="h5" color="#667085">
                    <CustomizeSpan><CreditCoinSmallIco /></CustomizeSpan> x 100
                </Typography>
                <CommonButton
                    value={"Buy Credits"}
                    onClick={() => {
                        setCreditsForm(true);
                    }}
                    padding={"10px 20px"}
                    borderRadius={"10px"}
                    fontWeight={"600"}
                    width={"250px"}
                />

            </CommonGrid2>
            <Dialog
                open={creditsForm}
                fullWidth
                maxWidth={"xs"}
            >
                <DialogContent
                    sx={{
                        padding: "1.5rem",
                        display: "flex",
                        flexDirection: "column",
                        gap: "1rem",
                    }}
                >
                    <Typography variant="h3">Buy Credits</Typography>
                    <CommonTextField
                        label={"How many credits do you want to purchase?"}
                        fontSize={"14px"}
                        padding={"10px"}
                        labelShrink={"10px"}
                        value={creditsFormValue?.requested_credits}
                        onChange={(e) =>
                            setCreditsFormValue((prev) => ({
                                ...prev, requested_credits: e.target.value
                            }))
                        }
                        type="number"
                    />
                    <CommonTextField
                        label={"Any additional notes?"}
                        fontSize={"14px"}
                        padding={"10px"}
                        labelShrink={"10px"}
                        value={creditsFormValue?.additional_notes}
                        onChange={(e) =>
                            setCreditsFormValue((prev) => ({
                                ...prev, additional_notes: e.target.value
                            }))
                        }
                    />
                    <CommonButton
                        value={"Send Request"}
                        padding={"8px 16px"}
                        fontSize={"14px"}
                        fontWeight={600}
                        disabled={loading || !creditsFormValue?.requested_credits}
                        onClick={handleSendCreditRequest}
                        loading={loading}
                    />
                    <CommonButton
                        value={"Cancel"}
                        padding={"8px 16px"}
                        fontSize={"14px"}
                        fontWeight={600}
                        variant="outlined"
                        onClick={() => {
                            setCreditsForm(false);
                            setCreditsFormValue({
                                requested_credits: "",
                                additional_notes: ""
                            })
                        }}
                    />

                </DialogContent>
            </Dialog>
            <Dialog
                open={successDialog}
                onClose={() => setSuccessDialog(false)}
                fullWidth
                maxWidth={"xs"}
            >
                <DialogContent
                    sx={{
                        padding: "1.5rem",
                        display: "flex",
                        flexDirection: "column",
                        gap: "1rem",
                        alignItems: "center",
                        textAlign: "center",
                    }}
                >
                    <Typography variant="h3" marginBottom={"0.5rem"}>
                        Request Received
                    </Typography>
                    <Typography variant="body1" color="#667085">
                        Your credit request has been received. Our team will update your credits soon.
                    </Typography>
                    <CommonButton
                        value={"Ok"}
                        padding={"8px 16px"}
                        fontSize={"14px"}
                        fontWeight={600}
                        marginTop={"0.5rem"}
                        onClick={() => setSuccessDialog(false)}
                    />
                </DialogContent>
            </Dialog>
            <SnackBar
                snackbarState={snackbarState}
                handleCloseValidation={handleCloseValidation}
            />
        </CommonGrid2>
    )
}

export default BuyCredits;